import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-[999] grid h-screen w-screen place-items-center" }
const _hoisted_2 = { class: "bg-mono-ns-100 rounded-3xl flex flex-col p-6 xl:p-10 font-sans items-center gap-4" }




export default /*@__PURE__*/_defineComponent({
  __name: 'ActionNotification',
  props: {
    message: {},
    type: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "rounded-full p-3 bg-sa-light text-mono-ns-100" }, [
        _createElementVNode("svg", {
          class: "w-6 h-6",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          _createElementVNode("path", {
            d: "M20 6.5L9 17.5L4 12.5",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          })
        ])
      ], -1)),
      _createElementVNode("h3", null, _toDisplayString(props.message), 1)
    ])
  ]))
}
}

})